module.exports = __webpack_public_path__ + "img/Logo.dd2aa545.svg";